/**
 * Session utilities — token expiry detection and clean logout.
 */

const AUTH_KEYS = ["token", "role", "firstname", "lastname", "rememberedEmail", "profileCompleted", "authProvider", "emailVerified"];

/** Returns true if the JWT is present but has already expired. */
export function isTokenExpired(token) {
  if (!token) return false;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload.exp) return false;
    return payload.exp * 1000 < Date.now();
  } catch {
    return false;
  }
}

/** Removes all auth keys from localStorage. */
export function clearSession() {
  AUTH_KEYS.forEach((k) => localStorage.removeItem(k));
}

/**
 * Call when a 401/403 is received mid-session.
 * Clears auth state and navigates to the login page with a session-expired flag.
 */
export function handleSessionExpiry(navigate) {
  clearSession();
  navigate("/login?session=expired", { replace: true });
}
